const SubAbasCores = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/adm/cores/cor/${id}/dadosgerais`,
  },
];

export default SubAbasCores;
